<template>
<div>
    <ShowAllOrders orderStatus="completed"></ShowAllOrders>
</div>
</template>

<script>
import ShowAllOrders from '@/components/App/dashboard/ShowAllOrders.vue';
export default {
    name: "CompleteTab",
    components: {
        ShowAllOrders
    }
}
</script>

<style>
</style>